import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

export default function FAQs() {
  const { t } = useTranslation();
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    API.get('/faqs').then(r => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <div className="page-header">
        <h1>{t('faqs.pageTitle')}</h1>
        <p>{t('faqs.pageSubtitle')}</p>
      </div>

      <section className="section">
        <div className="container" style={{ maxWidth: 800 }}>
          {faqs.map(faq => (
            <div key={faq._id} className="faq-item">
              <div className="faq-question" onClick={() => setOpen(open === faq._id ? null : faq._id)}>
                <span>{faq.question}</span>
                <span style={{ color: 'var(--saffron)', fontSize: '1.2rem', flexShrink: 0 }}>{open === faq._id ? '−' : '+'}</span>
              </div>
              <div className={`faq-answer${open === faq._id ? ' open' : ''}`}>
                {faq.answer}
              </div>
            </div>
          ))}

          <div style={{ background: '#FFF8F0', borderRadius: 12, padding: 28, textAlign: 'center', marginTop: 40, border: '1.5px solid #FFE0B2' }}>
            <div style={{ fontSize: '2rem', marginBottom: 8 }}>🐂</div>
            <h3 style={{ fontWeight: 700, marginBottom: 8 }}>{t('faqs.stillHaveQuestions')}</h3>
            <p style={{ color: '#777', marginBottom: 16 }}>{t('faqs.reachOut')}</p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/donations" className="btn btn-primary">{t('common.donateNow')}</Link>
              <Link to="/adopt-a-cow" className="btn btn-outline">{t('common.adoptACow')}</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
